<template>
    <div>
        <div>
            <div class="top-logo-bar" style="display: flex; align-items: center;" >
                <router-link :to="{name: 'login'}" style="align-items: left; display: flex">
                    <img class="app-logo" src="~@/assets/img/Menu/Logo.svg" style="margin-left:10vw ; height:35px; margin-top:0px; padding-right: 20px; border-right: 1px solid #AEAEAE7F"/>
                    <img class="app-logo" src="~@/assets/img/Menu/TransparencyLogo.svg" style="margin-left:20px;height:35px;margin-top:0px;"/>
                </router-link>
            </div>
        </div>
        <div class="policy-container">
            <div class="main-header">Registrer deg i mobilappen</div>
            <div style="padding-bottom: 30px;">
                <section>
                    <div class="section-header">1. Last ned CRFI+-applikasjonen til mobilen din</div>
                    <a href='https://play.google.com/store/apps/details?id=com.biocontrol.crfi_monitor&amp;pcampaignid=web_share&amp;pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1' style='display: inline-block; overflow: hidden;'><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style='height: 65px; object-fit: contain;'/></a>
                    <a href='https://apps.apple.com/us/app/crfi/id6445917147?itsct=apps_box_badge&amp;itscg=30200' style='display: inline-block; overflow: hidden; padding: 10px;'><img src='https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;amp;releaseDate=1658707200' alt='Download on the App Store' style='height: 45px; object-fit: contain;'></a>
                </section>
                <section>
                    <div class="section-header">2. Åpne appen</div>
                </section>
                <section>
                    <div class="section-header">3. Klikk på "Registrer" nederst i høyre hjørne.</div>
                    <div class="horizontal" style="justify-content: center;">
                        <img src="../assets/img/Instruction/MainScreen.jpeg" style="height: 450px;">
                    </div>
                </section>
                <section>
                    <div class="section-header">4. Fyll ut registrering med e-postadressen din (som du fikk e-post med invitasjonskode til) og invitasjonskoden tilsvarende. <br/> Klikk på "Bekreft" for å sjekke om invitasjonskoden og e-postadressen stemmer overens.</div>
                    <div class="horizontal" style="justify-content: center;">
                        <img src="../assets/img/Instruction/InvitationCode.png" style="height: 450px;">
                    </div>
                </section>
                <section>
                    <div class="section-header">5. Fyll ut informasjon om kontoen din.</div>
                    <div class="horizontal" style="justify-content: center;">
                        <img src="../assets/img/Instruction/Informations.png" style="height: 450px;">
                    </div>
                </section>
                <section>
                    <div class="section-header">6. Vellyket. Nå kan du logge inn.</div>
                    <div class="horizontal" style="justify-content: center;">
                        <img src="../assets/img/Instruction/Success.png" style="height: 450px;">
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>
.top-logo-bar {
    width: 100%;
    height: 100px;
    background: #347C93;
}

.section-header {
    margin-bottom: 20px;
    margin-top: 40px;
    font-weight: 600;
    font-size: 24px;
}

.main-header {
    font-weight: 700;
    font-size: 32px;
    margin-top: 20px;
}

section {
    padding-right: 40vw;
}

p {
    text-align: justify;
    /* margin-left: 2vw; */
}

li {
    font-weight: 700;
}

.policy-container {
    height: calc(100% - 100px); 
    overflow-y: scroll; 
    padding-left: calc(15vw + 30px);
}

@media only screen and (max-width: 700px) {
    .policy-container {
        padding-left: 5%;
    }

    section {
        padding-right: 5%;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/MobileRegisterInstructionNorsk.vue